import {Possessed} from "../Possessed";
import {PossessedGameAssets} from "../PossessedGameAssets";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {gsap} from "gsap"
import {PossessedSymbol, PossessedSymbolCreateArgs, PossessedSymbolStates} from "./PossessedSymbol";

export class PossessedWildSymbol extends PossessedSymbol
{
    private animation:PIXI.spine.Spine;

    public isExpandedWild:boolean = false;

    constructor(args:PossessedSymbolCreateArgs) {
        super(args);

        this.animation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.WILD_NUDGE_ANIMATION));
        this.addChild(this.animation);

        if(args.initialState == PossessedSymbolStates.STOP && Possessed.model.getWildSymbol()?.shouldExpand) {
            const stoppingReversed = Possessed.model.isFreespins();
            this.animation.state.setAnimation(0, stoppingReversed ? "wildspinUpward" : "wildspinDownward", true);
        } else {
            this.animation.visible = false;
        }
    }

    public initDefaultSymbolSprites(initState: PossessedSymbolStates) {
        super.initDefaultSymbolSprites(initState);

        // Wilds spin in as the only symbol not blurred for anticipation effect
        if(initState == PossessedSymbolStates.STOP) {
            this.mainSprite.alpha = 1;
            this.spinSprite.alpha = 0;
        }
    }

    resetState() {
        super.resetState();
        if(this.isExpandedWild) {
            this.spriteView.visible = false;
        }
    }

    getLandAnimation(): gsap.core.Timeline {
        const inHotzone = this.reelPosition > 0 && this.reelPosition < 5;
        const tl =  gsap.timeline();
        tl.add(()=>{
            SpineGSAPWrapper.resetSpineState(this.animation);
        })
        tl.add(SpineGSAPWrapper.createTimeline(this.animation, 0, "landing", 0))
        if(inHotzone == false) {
            tl.add(() => {
                Possessed.soundPlayer.playSoundWithDavidPanning("wildLand", this.reelID);
            }, "<")
        } else {
            tl.add(() => {Possessed.soundPlayer.playSoundWithDavidPanning("wildLandHotzone", this.reelID, 1, 0, 0, 50)}, "<");
        }
        tl.add(()=>{
            this.animation.visible = false;
        })
        return tl;
    }

    nudgeDown():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.spriteView.visible = false;
                SpineGSAPWrapper.resetSpineState(this.animation);
            })
            .add(SpineGSAPWrapper.createTimeline(this.animation, 0, "downstair", 0))
            .add(() => {
                this.spriteView.visible = true;
                this.animation.visible = false;
            })
    }

    expandUp():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.spriteView.visible = false;
                SpineGSAPWrapper.resetSpineState(this.animation);
                this.isExpandedWild = true;
            })
            .add(SpineGSAPWrapper.createTimeline(this.animation, 0, "expandUp", 0))
            .add(() => {
                Possessed.soundPlayer.playSound("wildNudge");
            }, "<")
            //.add(() => {
            //    this.mainView.visible = true;
            //    this.animation.visible = false;
            //})
    }

    expandFullCross():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.spriteView.visible = false;
                SpineGSAPWrapper.resetSpineState(this.animation);
                this.isExpandedWild = true;
            })
            .add(SpineGSAPWrapper.createTimeline(this.animation, 0, "expandFull", 0))
            .add(() => {
                Possessed.soundPlayer.playSound("wildNudge");
            }, "<")
            //.add(() => {
            //    this.mainView.visible = true;
            //    this.animation.visible = false;
            //})
    }

    public playWin(winRatio: number): gsap.core.Timeline {
        if(!this.isExpandedWild) {
            const tl = gsap.timeline();
            tl.add(Possessed.reelView.winFireView.playWinFireAt(winRatio, this.reelID, this.reelPosition));
            return tl;
        }
        else
            return gsap.timeline();
    }

    public playWinToggle(): gsap.core.Timeline {
        if(!this.isExpandedWild) {
            const tl = gsap.timeline()
                .add(Possessed.reelView.winFireView.playWinToggleAt(this.reelID, this.reelPosition));
            return tl;
        }
        else
            return gsap.timeline();
    }
}